@if (!isSearch) {
<div
  class="menu-container py-20px"
  [ngClass]="{'theme-sand': altBackground}"
  [@staggerAnimation]="open"
  (click)="$event.stopPropagation()">
  <div class="grid grid-cols-12 gap-y-24px">
    <div class="category col-span-12">
      <p class="label">{{ 'MENU.LANGUAGE.TITLE' | translate }}</p>
      <a class="link" (click)="switchLanguage('de')" (keydown)="switchLanguage('de')" tabindex="0">{{ 'MENU.LANGUAGE.GERMAN' | translate }}</a>
      <a class="link" (click)="switchLanguage('en')" (keydown)="switchLanguage('en')" tabindex="0">{{ 'MENU.LANGUAGE.ENGLISH' | translate }}</a>
    </div>
    <div class="category col-span-12 xl:col-span-2 sm:col-span-4 sm:px-8px">
      <p class="stagger-item label">
        <a
          class="link"
          [routerLink]="['/systems']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ 'MENU.SYSTEMS.TITLE' | translate }}
        </a>
      </p>
      @for (system of (systems$ | async)?.data; track system.slug) {
        <a
          class="stagger-item link"
          [routerLink]="['/systems', system.slug]"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ system.title }}
        </a>
      }
      <a
        class="stagger-item link"
        [routerLink]="['/systems']"
        [fragment]="'benefits'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.SYSTEMS.ALL_BENEFITS' | translate }}
      </a>
    </div>
    <div class="category col-span-12 xl:col-span-2 md:col-span-4 sm:col-span-4 sm:px-8px">
      <p class="stagger-item label">
        <a
          class="stagger-item link"
          [routerLink]="['/reagents']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ 'MENU.REAGENTS.TITLE' | translate }}
        </a>
      </p>
      <a
        class="stagger-item link"
        [routerLink]="['/reagents']"
        [fragment]="'collection'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.REAGENTS.COLLECTION' | translate }}
      </a>
      <a
        class="stagger-item link"
        [routerLink]="['/reagents']"
        [fragment]="'benefits'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.REAGENTS.ALL_BENEFITS' | translate }}
      </a>
    </div>
    <div class="category col-span-12 xl:col-span-2 sm:col-span-4 sm:px-8px">
      <p class="stagger-item label">
        <a
          class="stagger-item link"
          [routerLink]="['/company']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ 'MENU.COMPANY.TITLE' | translate }}
        </a>
      </p>
      <a
        class="stagger-item link"
        [routerLink]="['/company']"
        [fragment]="'mission'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.COMPANY.MISSION' | translate }}
      </a>
      <a
        class="stagger-item link"
        [routerLink]="['/company']"
        [fragment]="'history'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.COMPANY.HISTORY' | translate }}
      </a>
      <a
        class="stagger-item link"
        [routerLink]="['/company']"
        [fragment]="'team'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.COMPANY.TEAM' | translate }}
      </a>
    </div>
    <div class="category col-span-12 xl:col-span-2 sm:col-span-4 sm:px-8px">
      <p class="stagger-item label">
        <a
          class="link"
          [routerLink]="['/support']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ 'MENU.SUPPORT.TITLE' | translate }}
        </a>
      </p>
      <a
        class="stagger-item link"
        [routerLink]="['/product-archive']"
        routerLinkActive="router-link-active"
        [routerLinkActiveOptions]="{exact: true}"
        (click)="handleHostClick()"
        >
        {{ 'MENU.SUPPORT.PRODUCT_ARCHIVE' | translate }}
      </a>
      <a
        class="stagger-item link"
        [routerLink]="['/support']"
        [fragment]="'faq'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.SUPPORT.FAQ' | translate }}
      </a>
    </div>
    <div class="category col-span-12 xl:col-span-2 sm:col-span-4 sm:px-8px">
      <p class="stagger-item label">
        <a
          class="link"
          [routerLink]="['/jobs']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ 'MENU.JOBS.TITLE' | translate }}
        </a>
      </p>
      <a
        class="stagger-item link"
        [routerLink]="['/jobs']"
        [fragment]="'openings'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.JOBS.JOB_LISTINGS' | translate }}
      </a>
    </div>
    <div class="category col-span-12 xl:col-span-2 sm:col-span-4 sm:px-8px">
      <p class="stagger-item label">
        <a
          class="link"
          [routerLink]="['/contact']"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="handleHostClick()"
          >
          {{ 'MENU.CONTACT.TITLE' | translate }}
        </a>
      </p>
      <a
        class="stagger-item link"
        [routerLink]="['/contact']"
        [fragment]="'contactform'"
        (click)="handleHostClick()"
        >
        {{ 'MENU.CONTACT.REQUEST' | translate }}
      </a>
    </div>
  </div>
</div>
}
@if (isSearch) {
<div
class="menu-container px-32px sm:px-24px py-20px"
[ngClass]="{'theme-sand': altBackground}"
(click)="$event.stopPropagation()">
<app-modal-search [class.floating]="floating" (close)="handleHostClick()"></app-modal-search>
</div>
}
